import { customColors, defaultColors } from './colours';
import { ConfigurableThemeProps } from './theme.types';

export const storyBookProperty: ConfigurableThemeProps = {
  primaryBrandColour: customColors.primary,
  secondaryBrandColour: '#57737b',
  tertiaryBrandColour: defaultColors.lighterGrey,
  navigationFooterColour: '#182844',
  headerColour: defaultColors.lighterGrey,
  sectionTitleColour: customColors.primary,
  headerFont: 'Playfair Display',
  bodyFont: 'Open Sans',
};
